// auth.js
import { CognitoUser, AuthenticationDetails, CognitoUserSession, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { UserPool } from './auth-config';

export const login = (username: string, password: string) => {
  const user = new CognitoUser({ Username: username, Pool: UserPool });
  const authDetails = new AuthenticationDetails({ Username: username, Password: password });

  return new Promise((resolve, reject) => {
    user.authenticateUser(authDetails, {
      onSuccess: resolve,
      onFailure: reject,
    });
  });
};

export const getCurrentUser = ((): Promise<{ [key: string]: string }> => {
  return new Promise((resolve, reject) => {
    const cognitoUser = UserPool.getCurrentUser();
    if (!cognitoUser) {
      return null;
    }

    cognitoUser.getSession((err: any, session: CognitoUserSession) => {
      if (err) {
        return reject(err);
      }

      cognitoUser.getUserAttributes((err, attributes) => {
        if (err) {
          return reject(err);
        }

        const userDetails = attributes!.reduce((acc, attribute) => {
          acc[attribute.Name] = attribute.Value;
          return acc;
        }, {} as { [key: string]: string });

        resolve(userDetails);
      });
    });
  });
});

